const CSS_LENGTH_REGEX = /^\d+(\.\d+)?(px|em|rem|%|vw|vh|vmin|vmax|pt)$/i;
const CSS_FONT_SIZE_KEYWORDS = [
  'xx-small',
  'x-small',
  'small',
  'medium',
  'large',
  'x-large',
  'xx-large',
  'larger',
  'smaller'
];

export const isValidCssLength = (value: string | undefined) => {
  if (!value || !value.trim()) return true;
  return CSS_LENGTH_REGEX.test(value) || CSS_FONT_SIZE_KEYWORDS.includes(value.toLowerCase());
};

export const errorMessageForLengthVariable = (variable: string) =>
  `Invalid CSS length value for ${variable}. Expected a CSS length value. Example: "1.5rem" or "20px"`;
